export default "__VITE_ASSET__CtUXiGOi__"